import request from '@/utils/request'



export function customergroup(query) {
    return request({
        url: '/website/websitehome/customergroup/'+query.id,
        method: 'get',
        params: query
    })
}


export function customizedsolution(query) {
    return request({
        url: '/website/websitehome/customizedsolution',
        method: 'get',
        params: query
    })
}

export function customizedsolutionById(query) {
    return request({
        url: '/website/websitehome/customizedsolutionById',
        method: 'get',
        params: query
    })
}

